import type {Skill, UpdateIndustryExpertisesOperationRequest, UpdateSkillsRequest} from '@api';
import type {UpdateIndustryExpertiseRequest} from '~/types/domain/skill/Industry';

export const expertiseApiMapper = {
    toUpdateSkillsRequestApi: (newSelectedSkills: Skill[], newTopSkills: Skill[]): UpdateSkillsRequest => {
        return {
            updateProfileSkillsRequest: {
                topSkills: newTopSkills,
                selectedSkillsOrder: newSelectedSkills,
            },
        };
    },

    toUpdateIndustryExpertisesRequestApi: (request: UpdateIndustryExpertiseRequest): UpdateIndustryExpertisesOperationRequest => {
        return {updateIndustryExpertisesRequest: request};
    },
};
